<h1 *ngIf="!isAppMobile" tabindex="-1" class="dsd-t-3 dsd-mt-md">{{ titre | translate }}</h1>
<div *ngIf="coordonneesClient">
  <p *ngIf="doitAfficherAvertissementNumeroTelephonePrepayee">
    {{ 'caad.modifier.directiveCartePrepayee' | translate }}
  </p>
  <dsd-form-error-summary *ngIf="erreursSummary" errors="{{ erreursSummary | json }}"></dsd-form-error-summary>
  <dsd-alert *ngIf="!isCourriel()" variant="information" tabindex="-1">
    <h2 slot="title">{{ 'caad.accueil.alerte.horsEcran.information' | translate }}</h2>
    <p>{{ 'caad.modifier.alerte' | translate }}</p>
  </dsd-alert>
  <p class="dsd-b-30 dsd-fw-bold">{{ 'caad.modifier.coordonnees.champs' | translate }}</p>
  <app-saisie-adresse *ngIf="isCoordonnees()" [coordonneesClient]="coordonneesClient"></app-saisie-adresse>
  <app-saisie-telephone *ngIf="isTelephone()" [coordonneesClient]="coordonneesClient"></app-saisie-telephone>
  <app-saisie-courriel
    *ngIf="isCourriel()"
    [coordonneesClient]="coordonneesClient"
    [compteActif]="compteActif"></app-saisie-courriel>
</div>
